function Redirect({ ...rest }) {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M9.33333 6.55564V9.88897C9.33333 10.1837 9.21627 10.4663 9.0079 10.6746C8.79952 10.883 8.51691 11.0001 8.22222 11.0001H2.11111C1.81643 11.0001 1.53381 10.883 1.32544 10.6746C1.11706 10.4663 1 10.1837 1 9.88897V3.77786C1 3.48317 1.11706 3.20056 1.32544 2.99218C1.53381 2.78381 1.81643 2.66675 2.11111 2.66675H5.44444'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M7.66602 1H10.9993V4.33333'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.88867 7.11111L10.9998 1'
        stroke='currentColor'
        strokeWidth='1.75'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
}

export default Redirect;
